<template>
    <button
        type="button"
        @click="$emit('click')"
        class="interaction-btn"
        :class="{ 'is-complete': isComplete }"
        :aria-label="title"
        :disabled="disabled"
    >
        <SvgIcon :icon="icon" v-if="icon" class="interaction-btn__icon" :is-filled="iconFilled" />
        <span class="interaction-btn__text" v-if="title" v-text="title"/>
        <span class="interaction-btn__count" v-if="count" v-text="`+${count}`" />
    </button>
</template>
<script>
import SvgIcon from '@components/SvgIcon.vue';

export default {
    name: 'InteractionButton',
    components: { SvgIcon },
    props: {
        icon: {
            type: String,
            default: null,
        },
        iconFilled: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
        },
        isComplete: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        count: {
            type: Number,
            default: null
        }
    },
}
</script>

<style scoped lang="scss">
@import '~@/theme/_variables.scss';

.interaction-btn {
    appearance: none;
    -webkit-appearance: none;
    display: flex;
    align-items: center;
    column-gap: .8rem;
    border: none;
    padding: .5rem 1rem;
    background-color: transparent;
    cursor: pointer;
    color: $text;

    .interaction-btn__icon {
        width: 2rem;
        height: 2rem;
        margin-right: 0;
        color: $text;
        touch-action: none;
        pointer-events: none;
    }

    .interaction-btn__text {
        font-family: Axiforma, sans-serif;
        font-size: 1.4rem;
        line-height: 1.7rem;
        color: currentColor;
        font-weight: 600;
    }

    .interaction-btn__count {
        background-color: #EFFDEF;
        color: #48873A;
        border-radius: .2rem;
        padding: .2rem .4rem;
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.2rem;
        opacity: 0.7;
    }

    &[disabled] {
        opacity: .4;
    }

    &.is-complete ,
    &.is-complete .interaction-btn__icon {
        color: $accent;
    }
}
</style>
